<script setup>

import Validation from "@/classes/global/Validation";

const emits = defineEmits(['update:modelValue', 'update:validationFail',
  'min-number-reached','max-number-reached','focusout', 'keydown', 'input', 'blur', 'click' ]);

const props = defineProps({

  modelValue: {},

  inputType: {type: String, default: 'text'},
  cssStyle: {type: String},
  validationFail: {type: Object, default: new Validation()},
  validationText: {type: Array, default: ['Required']},
  disable: {type: Boolean, default: false},
  readonly: {type: Boolean, default: false},
  placeholder: {type: String},
  width: {type: Number, default: 50},
  maxLength: {type: Number, default: 12},
  maxNumber: {type: Number, default: Infinity},
  minNumber: {type: Number, default: 0},
  allowDecimal: {type: Boolean, default: false},
  label: {type: String, default: ''},
  labelTop: {type: Boolean, default: false,},
  labelWidth: {type: Number, default: 105},
  requiredField: {type: Boolean, default: false}
})

function maxMinNumberCheck(e) {

  let value = e.target.value;

  if (value !== "") {

    if (props.maxNumber > 0) {
      if (value > props.maxNumber || value.length > props.maxLength) {
        e.preventDefault();
        emits('update:validationFail', new Validation(1, true));
        emits('max-number-reached', value);
        return
      }
    }

    if (props.minNumber >= 0) {
      if (value < props.minNumber) {

        emits('update:validationFail', new Validation(1, true));
        emits('min-number-reached', value);

      } else {
        emits('update:validationFail', new Validation());
        emits('update:modelValue', value);
      }
    }

  } else {
    emits('update:modelValue', value);
  }

};

function filterChars(e) {

  if (!props.allowDecimal) {
    if (!(/[0-9]/.test(e.key))) {
      e.preventDefault();
    }

  } else {
    if (!(/[0-9]/.test(e.key))) {
      if (e.key !== '.') {
        e.preventDefault();

      } else {
        let split = e.target.value.split(".");
        if (split.length > 1 || e.target.value === "") {
          e.preventDefault();
        }

      }
    }
  }

};

function handleFocusOut() {
  emits('update:validationFail', new Validation());
  emits('focusout')
};

function handleClear(value) {
  if (value === '') {
    emits('update:validationFail', new Validation());
    emits('update:modelValue', '')
  }
}

</script>

<template>
  <div id="Vue-3-component-number-only-input">
    <TextInput
        id="text-input"
        :placeholder="placeholder"
        type="search"
        :label="label"
        :label-top="labelTop"
        :labelWidth="labelWidth"
        :requiredField="props.requiredField"
        :clearable="false"
        autocomplete="off"
        :width="width"
        :readonly="readonly"
        :disable="disable"
        :validation-fail="validationFail"
        :validation-text="validationText"
        v-model="modelValue"
        :maxLength="maxLength"
        @keydown="$emit('keydown', $event)"
        @click="$emit('click', $event)"
        @blur="$emit('blur', $event)"
        @focusout="handleFocusOut"
        @keypress="filterChars"
        @update:modelValue="handleClear"
        @input="$emit('input', $event.target.value), maxMinNumberCheck($event)">
    </TextInput>
  </div>
</template>
